import moment from 'moment';
import React, { useEffect, useState } from 'react';
import Select from 'react-select';
import { setDateHelper } from '../../utils/Helper';
import useMakeRequest from '../../utils/ApiHelper';
import { ApiConstants } from '../../constants/ApiConstants';
import Button from '../../components/ui/Button';
import CustomReactSelect from '../../components/ui/CustomReactSelect';
interface CustomModalProps {
    title: string;
    title2?: string;
    buttonTxt?: string;
    buttonTxt2?: string;
    toggleModal: () => void;
    onConfirm: () => void;
}


const FinalizeContributionInfoModal = ({ title2, buttonTxt = 'Confirm', buttonTxt2 = 'Cancel', toggleModal, onConfirm }: CustomModalProps) => {




    return (
        <div className="modal fade bottom-sheet-modal" id="FinalizeContributionInfo" tabIndex={-1} aria-labelledby="FinalizeContributionInfoLabel" aria-hidden="true" data-bs-backdrop="static" data-bs-keyboard="false">
            <div className="modal-dialog">
                <div className="modal-content">
                    {/* Bottom Sheet Handle */}
                    <div className="bottom-sheet-handle">
                        <div className="handle-bar"></div>
                    </div>

                    <div className="modal-header">
                        <h1 className="modal-title" id="editAllChoresUpdateModalLabel">{title2}</h1>
                    </div>

                    {/* <span className="form-title-control" style={{ padding: '0 20px', display: 'block', fontSize: '14px', color: '#6B7280' }}>
                        {title2}
                    </span> */}


                    <div className='custom-modal-foot mt-3 mb-3 page-padding-x'>
                        <button className='custom-modal-btn modal-light-btn' onClick={toggleModal}>{buttonTxt2}</button>
                        <button className='custom-modal-btn modal-dark-btn' onClick={onConfirm}>{buttonTxt}</button>
                    </div>

                </div>
            </div>
        </div>
    );
};

export default FinalizeContributionInfoModal;